import { render, staticRenderFns } from "./GameReportList.vue?vue&type=template&id=38b37fb4"
import script from "./GameReportList.vue?vue&type=script&lang=js"
export * from "./GameReportList.vue?vue&type=script&lang=js"
import style0 from "./GameReportList.vue?vue&type=style&index=0&id=38b37fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports